import { Component } from "@angular/core";
import { UsersListingComponent } from "./components/users-listing/users-listing.component";

@Component({
  selector: "jni-users",
  templateUrl: "./users.component.html",
  standalone: true,
  imports: [UsersListingComponent],
  styleUrls: ["./users.component.scss"],
})
export class UsersComponent {}
